var _path, _line, _path2, _line2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOxygenSaturation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    d: "M10.4,10.2L10.4,10.2c3.2,0,5.9,2.6,5.9,5.9v20.6l0,0H4.5l0,0V16.1C4.5,12.8,7.1,10.2,10.4,10.2z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    x1: 10.4,
    y1: 2.8,
    x2: 10.4,
    y2: 10.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    d: "M32.5,19v6.6c0,2.8-2.3,5.1-5.2,5.2l0,0c-2.8,0-5.1-2.3-5.1-5.1V13.1c0-4.1-3.3-7.4-7.4-7.4c0,0-0.1,0-0.1,0H5.9"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    x1: 16.3,
    y1: 30.8,
    x2: 8.9,
    y2: 30.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    d: "M36.9,15.3c0,2.8-2,3.7-4.4,3.7S28,18.2,28,15.3s2-6.6,4.4-6.6S36.9,12.5,36.9,15.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxygenSaturation);
export default __webpack_public_path__ + "static/media/OxygenSaturation.28389cd156a54bbc1be0f53ef9a42b7b.svg";
export { ForwardRef as ReactComponent };